import * as React from "react";

const IntegerEnum = (props: any) => (
  <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M20 0v20H0V0z" />
      <path fill="#7B838C" d="M7.273 0v20H5.455V0zM14.545 0v20h-1.818V0z" />
    </g>
  </svg>
);

export default IntegerEnum;

